import React from "react";
import { MatterOverviewSection } from "../types";

interface SidebarProps {
  sections: readonly MatterOverviewSection[];
  activeSection: MatterOverviewSection;
  onSectionChange: (section: MatterOverviewSection) => void;
}

const MatterOverviewSidebar: React.FC<SidebarProps> = ({
  sections,
  activeSection,
  onSectionChange,
}) => {
  return (
    <aside className="w-64 pr-4 bg-white">
      <ul className="space-y-2">
        {sections.map((section) => (
          <li key={section}>
            <button
              className={`w-full text-left px-3 py-2 rounded-lg transition ${
                activeSection === section
                  ? "bg-blue-500 text-white"
                  : "hover:bg-gray-100"
              }`}
              onClick={() => onSectionChange(section)}
            >
              {section}
            </button>
          </li>
        ))}
      </ul>
    </aside>
  );
};

export default MatterOverviewSidebar;
